// Type roles from design.md (Type scale). Use these, not one-off sizes.

/** Page h1: the display face (Fraunces Light) at the display step. */
export const pageTitleClass =
  'font-display text-[32px] leading-[1.1] tracking-[-0.02em] text-balance text-foreground max-[640px]:text-[28px] max-[640px]:leading-[1.12]'

/** KPI / inventory count: same optical size as the page title, but the UI face. */
export const metricValueClass =
  'text-[32px] font-normal leading-none tracking-[-0.02em] tabular-nums text-foreground max-[640px]:text-[28px]'

/** Section / card / dialog title. */
export const sectionTitleClass =
  'font-display text-xl leading-[1.2] tracking-[-0.02em] text-balance text-foreground'

/** Chrome wordmark, display face; colour is applied by the caller. */
export const wordmarkClass =
  'font-serif font-normal text-xl leading-none tracking-[-0.02em] whitespace-nowrap'

export const bodyClass = 'text-base font-normal leading-[1.55] text-foreground'

/** Reading column for ledes, empty-state copy, and rendered markdown. */
export const proseMeasureClass = 'max-w-[740px]'

export const ledeClass = `${proseMeasureClass} text-base font-normal leading-[1.5] text-pretty text-gray-800`

export const captionClass = 'text-sm font-normal leading-[1.5] text-muted-foreground'

export const fieldLabelClass = 'text-sm font-normal leading-normal text-muted-foreground'
